import {
  EVENT_PLANNING_EQUIPMENT,
  EVENT_PLANNING_PEAK_DAYS,
  EVENT_PLANNING_PEAK_DAYS_ORDER,
  EVENT_PLANNING_RESOURCE_PLAN,
  INBOUND_VOLUME,
  EVENT_PLANNING_VOLUME_BY_WEEK,
  EVENT_PLANNING_PICK_VOLUME,
  EVENT_PLANNING_PICK_PLAN,
  EVENT_PLANNING_RESERVE_CAPACITY,
  EVENT_PLANNING_FLOOR_CAPACITY,
  EVENT_PLANNING_RECRUITMENT_PLAN,
} from "../../plannerConfig";

export const PEAK_DAY_TAB_TITLE = "Peak Days (Disp)";
export const OUTBOUND_VOLUME_TAB_TITLE = "Outbound Volume";
export const INBOUND_VOLUME_TAB_TITLE = "Inbound Volume";
export const VOLUME_BY_WEEK_TAB_TITLE = "Volume By Week";
export const PICK_VOLUME_TAB_TITLE = "Pick Volume";
export const EQUIPMENT_TAB_TITLE = "Equipment";
export const RESOURCE_PLAN_TAB_TITLE = "Resource Plan";
export const RECRUITMENT_PLAN_TAB_TITLE = "Recruitment Plan";
export const RESERVE_CAPACITY_TAB_TITLE = "Reserve Capacity";
export const PEAK_DAYS_ORDER_TAB_TITLE = "Peak Days (Order)";
export const PICK_PLAN_TAB_TITLE = "Pick Plan";
export const FLOOR_CAPACITY_TAB_TITLE = "Floor Capacity";

const PEAK_DAY_COLOUR = "#FFD54F";
const OUTBOUND_VOLUME_COLOUR = "#29B6F6";
const INBOUND_VOLUME_COLOUR = "#F44336";
const VOLUME_BY_WEEK_COLOUR = "#E91E63";
const PICK_VOLUME_COLOUR = "#8E24AA";
const EVENT_PLANNING_EQUIPMENT_COLOUR = "#303F9F";
const EVENT_PLANNING_RESOURCE_PLAN_COLOUR = "#1E88E5";
const EVENT_PLANNING_RECRUITMENT_PLAN_COLOUR = "#8BC34A";
const EVENT_PLANNING_RESERVE_CAPACITY_COLOUR = "#26A69A";
const EVENT_PLANNING_PEAK_DAYS_ORDER_COLOUR = "#64B5F6";
const EVENT_PLANNING_PICK_PLAN_COLOUR = "#FFD54F";
const EVENT_PLANNING_FLOOR_CAPACITY_COLOUR = "#F48FB1";

const dashboardTabs = [
  {
    title: PEAK_DAY_TAB_TITLE,
    colour: PEAK_DAY_COLOUR,
  },
  {
    title: PEAK_DAYS_ORDER_TAB_TITLE,
    colour: EVENT_PLANNING_PEAK_DAYS_ORDER_COLOUR,
  },
  {
    title: VOLUME_BY_WEEK_TAB_TITLE,
    colour: VOLUME_BY_WEEK_COLOUR,
  },
  {
    title: INBOUND_VOLUME_TAB_TITLE,
    colour: INBOUND_VOLUME_COLOUR,
  },
  {
    title: PICK_VOLUME_TAB_TITLE,
    colour: PICK_VOLUME_COLOUR,
  },
  {
    title: PICK_PLAN_TAB_TITLE,
    colour: EVENT_PLANNING_PICK_PLAN_COLOUR,
  },
  {
    title: RESOURCE_PLAN_TAB_TITLE,
    colour: EVENT_PLANNING_RESOURCE_PLAN_COLOUR,
  },
  {
    title: RESERVE_CAPACITY_TAB_TITLE,
    colour: EVENT_PLANNING_RESERVE_CAPACITY_COLOUR,
  },
  {
    title: FLOOR_CAPACITY_TAB_TITLE,
    colour: EVENT_PLANNING_FLOOR_CAPACITY_COLOUR,
  },
  {
    title: EQUIPMENT_TAB_TITLE,
    colour: EVENT_PLANNING_EQUIPMENT_COLOUR,
  },
  {
    title: RECRUITMENT_PLAN_TAB_TITLE,
    colour: EVENT_PLANNING_RECRUITMENT_PLAN_COLOUR,
  },
];

export const eventPlanningEntitiesKeyedByDashboardTab = {
  [PEAK_DAY_TAB_TITLE]: EVENT_PLANNING_PEAK_DAYS,
  [PEAK_DAYS_ORDER_TAB_TITLE]: EVENT_PLANNING_PEAK_DAYS_ORDER,
  [VOLUME_BY_WEEK_TAB_TITLE]: EVENT_PLANNING_VOLUME_BY_WEEK,
  [INBOUND_VOLUME_TAB_TITLE]: INBOUND_VOLUME,
  [PICK_VOLUME_TAB_TITLE]: EVENT_PLANNING_PICK_VOLUME,
  [PICK_PLAN_TAB_TITLE]: EVENT_PLANNING_PICK_PLAN,
  [RESOURCE_PLAN_TAB_TITLE]: EVENT_PLANNING_RESOURCE_PLAN,
  [RESERVE_CAPACITY_TAB_TITLE]: EVENT_PLANNING_RESERVE_CAPACITY,
  [FLOOR_CAPACITY_TAB_TITLE]: EVENT_PLANNING_FLOOR_CAPACITY,
  [EQUIPMENT_TAB_TITLE]: EVENT_PLANNING_EQUIPMENT,
  [RECRUITMENT_PLAN_TAB_TITLE]: EVENT_PLANNING_RECRUITMENT_PLAN,
};

const defaultActiveTab = {
  title: PEAK_DAY_TAB_TITLE,
  colour: PEAK_DAY_COLOUR,
};

export default { dashboardTabs, defaultActiveTab };
